import styled from "styled-components";

// Layout and type primitives shared by the home page sections

export const Section = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 3.5rem 2rem;

  @media screen and (max-width: 48em) {
    padding: 2.5rem 1rem;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
`;

// Large rounded block, the visual unit of the page
export const Panel = styled.div`
  width: 100%;
  max-width: 1280px;
  border-radius: 48px;
  padding: 5rem 4rem;
  background: ${(props) => (props.$dark ? "var(--ink-900)" : "var(--paper-2)")};
  color: ${(props) => (props.$dark ? "var(--text-inv)" : "var(--text-hi)")};

  @media screen and (max-width: 64em) {
    padding: 4rem 2.5rem;
  }

  @media screen and (max-width: 48em) {
    border-radius: 32px;
    padding: 3rem 1.5rem;
  }
`;

export const Eyebrow = styled.p`
  font-family: var(--fontR);
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${(props) => props.$color || "var(--text-lo)"};
  margin-bottom: 1rem;
`;

export const H2 = styled.h2`
  font-family: var(--fontL);
  font-weight: 500;
  font-size: clamp(1.875rem, 3.4vw, 2.5rem);
  line-height: 1.15;
  letter-spacing: -0.025em;
  margin-bottom: 1rem;
  text-wrap: balance;
`;

export const Lead = styled.p`
  font-family: var(--fontR);
  font-size: 1.0625rem;
  line-height: 1.6;
  color: ${(props) => (props.$dark ? "#b4b4ba" : "var(--text-lo)")};
  max-width: 34rem;
`;

export const CenteredHead = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 3rem;

  @media screen and (max-width: 48em) {
    margin-bottom: 2rem;
  }
`;
